import React from "react";
import "../styles/user_management_styles.css";
import Navbar from "./Navbar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import MultiSelect from "./MultiSelect.js";
import useFetch from "./useFetch.js";
import swal from "sweetalert";
import axios from "axios";
import config from "../config.js";
import Cookie from "universal-cookie";
import mixpanel from "mixpanel-browser";

const Alarms_Delete = () => {
  const cookies = new Cookie();
  let actionInitiatingUser = -1;
  let userToken = "";
  try {
    actionInitiatingUser = parseInt(cookies.get("userID"));
    userToken = cookies.get("userToken");
  } catch {}

  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  const {
    data: alarms,
    isPending: isPendingAlarms,
    error: errorAlarms,
  } = useFetch({
    actionInitiatingUser: actionInitiatingUser.toString(),
    URL: config.BACKEND_URL + "/alarms",
  });

  let alarmsToBeDeleted = [];

  const handleDelete = async (e) => {
    e.preventDefault();
    mixpanel.track("Create Alarm Delete Button Clicked", {
      userID: cookies.get("userID"),
    });

    if (alarmsToBeDeleted.length === 0) {
      swal(
        "No alarms selected!",
        "Please select at least one alarm first...",
        "error"
      );
      return;
    }

    try {
      swal({
        title: "Are you sure?",
        text: `Do you want to delete ${alarmsToBeDeleted.length} alarms?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          for (let alarmID of alarmsToBeDeleted) {
            await axios.delete(
              config.BACKEND_URL + `/alarms/${alarmID}/${actionInitiatingUser}`,
              { headers }
            );
          }
          swal(
            "Alarm deleted successfully!",
            "Click OK to continue...",
            "success"
          ).then(() => window.location.reload());
        } else {
          swal("Alarms not deleted!", "", "info");
        }
      });
    } catch {
      swal("Error deleting alarm!", "", "error");
    }
  };

  const handleChange = (selected) => {
    alarmsToBeDeleted = selected.map((s) => s.value);
  };

  return (
    <div
      className="Alarms d-flex flex-column"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top, #1e293b 0%, #020617 45%, #020617 100%)",
      }}
    >
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <Navbar />

      {/* MAIN */}
      <main className="container-fluid py-4">
        {/* HEADER */}
        <section className="text-center mb-4">
          <h2 className="fw-bold" style={{ color: "rgba(226,232,240,0.95)" }}>
            Delete Alarms
          </h2>
          <p style={{ color: "rgba(203,213,225,0.8)", fontSize: "1.1rem" }}>
            Select the alarms you wish to delete
          </p>
        </section>

        {/* GLASS CARD */}
        <div
          className="mx-auto"
          style={{
            width: "100%",
            maxWidth: "700px",
            padding: "24px",
            background: "rgba(15,23,42,0.65)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            borderRadius: "16px",
            border: "1px solid rgba(148,163,184,0.15)",
            boxShadow:
              "0 0 0 1px rgba(255,255,255,0.04), 0 10px 30px rgba(59,130,246,0.25)",
          }}
        >
          <form onSubmit={handleDelete}>
            {/* MULTISELECT */}
            <div className="d-flex justify-content-center mb-4">
              {isPendingAlarms && (
                <div
                  style={{
                    fontSize: 18,
                    color: "rgba(203,213,225,0.8)",
                  }}
                >
                  Loading...
                </div>
              )}

              {errorAlarms && (
                <div
                  style={{
                    fontSize: 18,
                    color: "rgba(203,213,225,0.8)",
                  }}
                >
                  Cannot fetch alarms right now!
                </div>
              )}

              {alarms &&
                (alarms.length === 0 ? (
                  <div
                    style={{
                      fontSize: 18,
                      color: "rgba(203,213,225,0.8)",
                    }}
                  >
                    Currently, there are no alarms!
                  </div>
                ) : (
                  <div style={{ width: "100%", maxWidth: "500px" }}>
                    <MultiSelect
                      handleChange={handleChange}
                      placeholder={"Search or select alarms..."}
                      data={alarms.map((a) => ({
                        value: a.id,
                        label: a.title,
                      }))}
                      defaultSelected={[]}
                      dropdownStyle={{ color: "black" }}
                    />
                  </div>
                ))}
            </div>

            {/* DELETE BUTTON */}
            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="btn"
                style={{
                  background: "rgba(220,38,38,0.9)",
                  color: "white",
                  padding: "12px 32px",
                  fontSize: "1rem",
                  borderRadius: "12px",
                  transition: "0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow = "0 0 14px rgba(239,68,68,0.8)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Delete Alarms
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Alarms_Delete;
